<template>
  <div class="btn__wrapper">
    <button
      type="button"
      class="btn btn--green btn--arrow"
      @click.once="handleClick('yes')"
    ><span>YES</span></button>
    <button
      type="button"
      class="btn btn--red btn--arrow"
      @click.once="handleClick('no')"
    ><span>NO</span></button>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick (value) {
      this.$emit('input', value)
    }
  }
}
</script>
